module.exports = __webpack_public_path__ + "img/partner_icon6.14d76f1a.png";